import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-residence-unit',
  templateUrl: './residence-unit.component.html',
  styleUrls: ['./residence-unit.component.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule],
})
export class ResidenceUnitComponent {
  @Input({ required: true })
  get dataSource(): any {
    return this._dataSource;
  }
  set dataSource(value: any) {
    this._dataSource = value;
  }
  private _dataSource!: any;
  router = inject(Router);

  goToCity(cityUrl: string) {
    this.router.navigate([cityUrl]);
  }
}
